import React from "react";
import "../styles/Loader.css";

const Loader = () => {
  return (
    <div className="container_loader">
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
      <div className="bar"></div>
    </div>
  );
};

export default Loader;
